import base from './base2.repository';
export default {
    get: (params) => base.get('rounds', params),
    save: (payload) => base.post('rounds', payload),
    delete: (id) => base.delete(`rounds/${id}`),
    saveControlPoint: (payload) => base.post('rounds/control-points', payload),
    updateControlPointsOrder: (payload) => base.post('rounds/control-points/update-order', payload),
    saveChecklistItem: (payload) => base.post('rounds/checklist', payload),
    removeChecklistItem: (id) => base.delete(`rounds/checklist/${id}/remove-item`),
    sendControlPointConfig: (payload) => base.post('rounds/control-points/set-config', payload),
    getInstances: params => base.get('rounds/instances', params),
    getCheckpoints: id => base.get(`rounds/instances/${id}/checkpoints`),
    getControlPointsByClient: (clientId) => base.get('rounds/control-points/by-client', { clientId })
}